import { useContext } from 'react';

import { CMSPublicComponentsContext } from './CMSPublicComponentsContext';

/** Get public loyalty components */
export const useCMSPublicComponents = () =>
  useContext(CMSPublicComponentsContext);
